/**
 * Template Designer Test Page
 *
 * This is a standalone test page for the Template Designer component.
 * Access it at: /template-designer
 *
 * This page allows testing the component independently from the main app flow.
 */

import { TemplateDesigner } from '@/components/TemplateDesigner';

export default function TemplateDesignerTest() {
  return <TemplateDesigner />;
}
